import { createRouter, createWebHistory } from "vue-router";
import HomeComponent from '../components/HomeComponent.vue';
import LegalNotice from '../components/LegalNotice.vue';
import PrivacyPolitics from '../components/PrivacyPolitics.vue';
const routes = [
    { path: '/', name: 'home', component: HomeComponent, meta: {
        title: "GMA Logistics",
        description: "GMA Logistics vous accompagne avec des solutions de stockage, transport et livraison sur mesure."
    }},
    { path: '/mentions-legales', name: 'legal', component: LegalNotice },
    { path: '/politique-de-confidentialite', name: 'privacy', component: PrivacyPolitics }
]
const router = createRouter({
    history: createWebHistory(),
    routes,
    
    scrollBehavior(to) {
        if (!to.hash) {
          return { 
            top: 0, 
            behavior: 'auto' 
          }
        }
        
        return { 
          el: to.hash,
          behavior: 'smooth',
          top: 120 
        }
      }
    })

router.afterEach((to) => {
    document.title = to.meta?.title || "GMA Logistics - Votre expert logistique";
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.setAttribute("name", "description");
        document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", to.meta?.description || "Solutions et stockage sur mesure avec GMA Logistics.");
});
 
export default router;